import { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useRouter } from "next/router";
import {
    edit_my_data_saga,
    get_inputs_values,
    get_me_act,
    set_my_info_act,
    set_file_saga
} from "../store/actions/my-info";
import {
    get_city,
    get_country,
    get_gender
} from "../store/actions/general";
import Category from '../services/api/general';

const MyInfo = (props) => {
    const edit = useSelector(state => state.edit);
    const user = useSelector(state => state.getme.data);
    const [open, setOpen] = useState(false);
    const [openCity, setOpenCity] = useState(false);
    const [openPhone, setOpenPhone] = useState(false);
    const [sendEmail, setSendEmail] = useState(user?.send_email);
    const router = useRouter();
    const dispatch = useDispatch();
    const edit_my_data = (token) => dispatch(
        edit_my_data_saga({ token, ...edit.data,send_email:sendEmail  })
    );
    const keyPress = (e) => {
        if (e.key === "Enter") {
            edit_my_data(props.token)
        }
    };
    const get_inputs_values_act = (data) => {
        dispatch(get_inputs_values(data));
    };
    const set_file = (data) => {
        dispatch(set_file_saga({ ...data }));
    };
    const log_out = () => {
        dispatch(get_me_act());
    };
    const handleSendEmail = useCallback(()=>{
        setSendEmail(!sendEmail)
    },[sendEmail])
    const handleClose = () => dispatch(close_alert());
    const translate = useSelector(state => state.translate);
    async function my_func() {
        const data = props.user;
        if (props.loggedIn) {
            const country = await Category.get_city();
            const gender = await Category.get_gender();
            dispatch(get_city(country));
            dispatch(get_gender({ ...gender }));
            // if (country.results.length > 0) {
            //     const city = await Category.get_city({ country: data.city_details && data.city_details.country ? data.city_details.country : country.results[0].id });
            //     dispatch(get_city({ ...city }));
            // }
            var user_edit = {
                username: user.user.username,
                first_name: user.user.first_name,
                last_name: user.user.last_name,
                email: user.user.email,
                is_active: user.user.is_active,
                about: user.about,
                address: user.address,
                address_latitude: user.address_latitude,
                address_longitude: user.address_longitude,
                birth_date: user.birth_date,
                brands: user.brands,
                city: user.city,
                country: user.city_details ? user.city_details.country : null,
                city_latitude: user.city_latitude,
                city_longitude: user.city_longitude,
                created_at: user.created_at,
                gender: user.gender,
                google_calendar_id: user.google_calendar_id,
                id: user.id,
                image: user.image,
                is_client: user.is_client,
                is_master: user.is_master,
                is_removed: user.is_removed,
                phone_number: user.phone_number,
                push_token: user.push_token,
                rating: user.rating,
                stripe_client_id: user.stripe_client_id,
                stripe_customer_id: user.stripe_customer_id,
                zip_code: user.zip_code,
                city_details: user.city_details,
            }
            setTimeout(
                function () {
                    dispatch(set_my_info_act(user_edit))
                },
                1000
            );
        } else {
            router.push("/login")
            // router.replace("/my-profile", "/login", { shallow: true });
        }
    }
    useEffect(() => {
        my_func()
    }, [props.loggedIn]);
    return {
        user,
        edit,
        router,
        open,
        openPhone,
        translate,
        openCity,
        sendEmail,
        handleSendEmail,
        get_inputs_values_act,
        edit_my_data,
        set_file,
        keyPress,
        setOpen,
        setOpenPhone,
        log_out,
        setOpenCity
    }
}
export default MyInfo;